import { useMemo } from 'react'

import { useGroupFilter } from '../../groupFilter'
import {
  api as tableApi,
  configs as tableConfigs,
} from '../../table/hooks/useApi'
import useBbbCorporateInventory, {
  bbbCorporateInventoryConfigs,
} from '../../tableV2/hooks/bbb/useCorporateInventory'
import useBbbCorporatePurchase, {
  bbbCorporatePurchaseConfigs,
} from '../../tableV2/hooks/bbb/useCorporatePurchase'
import useBbbFlash, { bbbFlashConfigs } from '../../tableV2/hooks/bbb/useFlash'
import useBbbLocationPurchase, {
  bbbLocationPurchaseConfigs,
} from '../../tableV2/hooks/bbb/useLocationPurchase'
import useBbbPnlRankings, {
  bbbPnlRankingsConfigs,
} from '../../tableV2/hooks/bbb/usePnLRankings'
import useBibibopRankings, {
  bibibopRankingsConfigs,
} from '../../tableV2/hooks/bbb/useRankings'
import useBurgerworksFlash, {
  burgerworksFlashConfigs,
} from '../../tableV2/hooks/burgerworks/useFlash'
import useBurgerworksRankings, {
  burgerworksRankingsConfigs,
} from '../../tableV2/hooks/burgerworks/useRankings'
import useMadeFromScratch, {
  madeFromScratchConfigs,
} from '../../tableV2/hooks/common/useMadeFromScratch'
import usePAndLRankings, {
  pAndLRankingsConfigs,
} from '../../tableV2/hooks/common/usePAndLRankings'
import useDhRankings, {
  dhRankingsConfigs,
} from '../../tableV2/hooks/dhWb/useRankings'
import useFwWingstopLocationIntraday, {
  fwWingstopLocationIntradayCsvConfigs,
} from '../../tableV2/hooks/fwWingstop/intraday/useLocationIntraday'
import useFwWingstopLossPrevention, {
  fwWingstopLossPreventionConfigs,
} from '../../tableV2/hooks/fwWingstop/lossPrevention/useLossPrevention'
import useFwWingstopDiscountAndVoid, {
  fwWingstopDiscountAndVoidConfigs,
} from '../../tableV2/hooks/fwWingstop/useDiscountAndVoid'
import useFwWingstopLastTwentyEightDaysTrendData, {
  fwWingstopLastTwentyEightDaysTrendDataConfigs,
} from '../../tableV2/hooks/fwWingstop/useLastTwentyEightDaysTrendData'
import useFwWingstopSalesAndCompTickets, {
  fwWingstopSalesAndCompTicketsConfigs,
} from '../../tableV2/hooks/fwWingstop/useSalesAndCompTickets'
import useFwWingstopSmgBreakdownByStore, {
  fwWingstopSmgBreakdownByStoreConfigs,
} from '../../tableV2/hooks/fwWingstop/useSmgBreakdownByStore'
import useGhaiPopWeekdayAvgLateNight, {
  ghaiPopWeekdayAvgLateNightConfigs,
} from '../../tableV2/hooks/ghaiPop/useGhaiPopWeekdayAvgLateNight'
import useIrmgBkTrendEodCompleted, {
  irmgBkTrendEodCompletedConfigs,
} from '../../tableV2/hooks/irmgBk/useTrendEodCompleted'
import useTimoneyRoundup, {
  roundupConfigs as timoneyRoundupConfigs,
} from '../../tableV2/hooks/timoney/useRoundup'
import useWingitnorthOutliers, {
  wingitnorthOutliersConfigs,
} from '../../tableV2/hooks/wingitnorth/useOutliers'
import { IApiDataType } from '../../tableV2/types'
import useBbbOpsDashboard, {
  bbbOpsDashboardConfigs,
} from './useBbbOpsDashboard'
import useDhWbFlashV2, { dhWbFlashV2Configs } from './useDhWbFlash'
import {
  fwCoreNoncoreSssBreakdownConfig,
  fwMarketSssBreakdownConfig,
  useFwCoreNoncoreSssBreakdown,
  useFwMarketSssBreakdown,
} from './useFwSssBreakdown'
import useFwWingstopDayPartOrderMode, {
  fwWingstopDayPartOrderModeConfigs,
} from './useFwWingstopDayPartOrderMode'
import useFwWingstopDigitalAndNondigital, {
  fwWingstopDigitalAndNondigitalConfigs,
} from './useFwWingstopDigitalAndNondigital'
import {
  useFwWingstopR365SalesbyOrderMode,
  useFwWingstopR365SalesbyOrderModeLocation,
} from './useFwWingstopR365SalesbyOrderMode'
import useFwWingstopSalesAlertDashboard, {
  fwWingstopSalesAlertDashboardConfig,
} from './useFwWingstopSalesAlertDashboard'
import useFwWingstopSalesbyOrderMode, {
  fwWingstopFlashSalesByOrderModeConfigs,
} from './useFwWingstopSalesbyOrderMode'
import useFwWingstopTimeClock, {
  fwWingstopTimeClockConfigs,
} from './useFwWingstopTimeClock'
import useItem, { itemV2Configs } from './useItem'
import useLfrBusinessReviewAndGuest, {
  lfrBusinessReviewAndGuestConfigs,
} from './useLfrBusinessReviewAndGuest'
import useManageLocations, {
  manageLocationsConfigs,
} from './useManageLocations'

export type IApiKeyType = keyof typeof api

export const configs = {
  ...tableConfigs,
  lfrBusinessReviewAndGuest: lfrBusinessReviewAndGuestConfigs,
  fwWingstopTimeClock: fwWingstopTimeClockConfigs,
  fwWingstopFlashSalesByOrderMode: fwWingstopFlashSalesByOrderModeConfigs,
  bbbFlashV2: bbbFlashConfigs,
  bbbPnlRankingsV2: bbbPnlRankingsConfigs,
  madeFromScratch: madeFromScratchConfigs,
  burgerworksFlashV2: burgerworksFlashConfigs,
  item: itemV2Configs,
  bbbOpsDashboard: bbbOpsDashboardConfigs,
  burgerworksRankings: burgerworksRankingsConfigs,
  dhWbFlashV2: dhWbFlashV2Configs,
  dhRankings: dhRankingsConfigs,
  irmgBkEodReport: irmgBkTrendEodCompletedConfigs,
  bbbRankings: bibibopRankingsConfigs,
  fwWingstopDiscountAndVoid: fwWingstopDiscountAndVoidConfigs,
  fwWingstopSalesAlertDashboard: fwWingstopSalesAlertDashboardConfig,
  fwWingstopDigitalAndNondigital: fwWingstopDigitalAndNondigitalConfigs,
  fwWingstopDayPartOrderMode: fwWingstopDayPartOrderModeConfigs,
  pAndLRankings: pAndLRankingsConfigs,
  timoneyRoundup: timoneyRoundupConfigs,
  bbbCorporatePurchase: bbbCorporatePurchaseConfigs,
  bbbCorporateInventory: bbbCorporateInventoryConfigs,
  bbbLocationPurchase: bbbLocationPurchaseConfigs,
  fwWingstopSalesAndCompTickets: fwWingstopSalesAndCompTicketsConfigs,
  ghaiPopWeekdayAvgLateNight: ghaiPopWeekdayAvgLateNightConfigs,
  fwWingstopSmgBreakdownByStore: fwWingstopSmgBreakdownByStoreConfigs,
  wingitnorthOutliers: wingitnorthOutliersConfigs,
  fwWingstopLocationIntraday: fwWingstopLocationIntradayCsvConfigs,
  fwWingstopLossPrevention: fwWingstopLossPreventionConfigs,
  fwMarketSssBreakdown: fwMarketSssBreakdownConfig,
  fwCoreNoncoreSssBreakdown: fwCoreNoncoreSssBreakdownConfig,
  fwLastTwentyEightDaysTrendData: fwWingstopLastTwentyEightDaysTrendDataConfigs,
  fwWingstopR365SalesbyOrderMode: fwWingstopFlashSalesByOrderModeConfigs,
  fwWingstopR365SalesbyOrderModeLocation:
    fwWingstopFlashSalesByOrderModeConfigs,
  manageLocations: manageLocationsConfigs,
}

// WARNING: it just a simple wrapper, maybe not match all case
const buildTableV2Wrapper = (
  useApi: () => { data: IApiDataType; loading: boolean },
  withoutGroupBy?: boolean,
) => {
  const useTableV2Wrapper = () => {
    const { data, loading } = useApi()
    const { groupFilter } = useGroupFilter()
    console.log(data)

    return {
      data: useMemo((): {
        source: Record<string, unknown>[]
        summary: Record<string, unknown> | null
      } | null => {
        if (!data || (!withoutGroupBy && !groupFilter?.list)) return null

        // Add orderIndex to data
        const dataWithIndex = data.map((d, index) => ({
          ...d,
          rowIndex: index + 1,
        }))

        if (!dataWithIndex.some((d) => d.id === 'summary')) {
          if (withoutGroupBy)
            return {
              source: data.map((d, index) => {
                const groupInfo = groupFilter?.list?.find(
                  (l) => l.id.toString() === d.id,
                )
                const copiedGroupInfo = !groupInfo
                  ? undefined
                  : { ...groupInfo }

                if (copiedGroupInfo) delete copiedGroupInfo.groupBy

                return {
                  ...d,
                  rowIndex: index + 1,
                  groupInfo: copiedGroupInfo,
                }
              }),
              summary: null,
            }

          return {
            source: (groupFilter?.list || [])
              .map((l) => {
                const locationData = dataWithIndex.find(
                  (d) => d.id === l.id.toString(),
                )
                const copiedGroupInfo = { ...l }

                if (withoutGroupBy) delete copiedGroupInfo.groupBy

                return {
                  ...locationData,
                  groupInfo: copiedGroupInfo,
                }
              })
              .sort((a, b) => (a.rowIndex || 0) - (b.rowIndex || 0)),
            summary: null,
          }
        }

        return {
          source: dataWithIndex
            .filter((d) => d.parentId === 'summary')
            .map((d) => {
              const groupInfo = groupFilter?.list?.find(
                (l) => l.id.toString() === d.id,
              )

              return {
                ...d,
                groupInfo,
              }
            })
            .sort((a, b) => a.rowIndex - b.rowIndex),
          summary:
            dataWithIndex.filter((d) => d.parentId === 'root')?.[0] || null,
        }
      }, [data, groupFilter]),
      loading,
    }
  }

  return useTableV2Wrapper
}

const api = {
  ...tableApi,
  lfrBusinessReviewAndGuest: useLfrBusinessReviewAndGuest,
  fwWingstopTimeClock: useFwWingstopTimeClock,
  fwWingstopFlashSalesByOrderMode: useFwWingstopSalesbyOrderMode,
  bbbFlashV2: buildTableV2Wrapper(useBbbFlash),
  bbbPnlRankingsV2: buildTableV2Wrapper(useBbbPnlRankings, true),
  madeFromScratch: buildTableV2Wrapper(useMadeFromScratch, true),
  burgerworksFlashV2: buildTableV2Wrapper(useBurgerworksFlash),
  item: useItem,
  bbbOpsDashboard: useBbbOpsDashboard,
  burgerworksRankings: buildTableV2Wrapper(useBurgerworksRankings, true),
  dhWbFlashV2: useDhWbFlashV2,
  dhRankings: buildTableV2Wrapper(useDhRankings, true),
  irmgBkEodReport: buildTableV2Wrapper(useIrmgBkTrendEodCompleted, true),
  bbbRankings: buildTableV2Wrapper(useBibibopRankings, true),
  fwWingstopDiscountAndVoid: buildTableV2Wrapper(useFwWingstopDiscountAndVoid),
  fwWingstopSalesAlertDashboard: useFwWingstopSalesAlertDashboard,
  fwWingstopDigitalAndNondigital: useFwWingstopDigitalAndNondigital,
  fwWingstopDayPartOrderMode: useFwWingstopDayPartOrderMode,
  pAndLRankings: buildTableV2Wrapper(usePAndLRankings, true),
  timoneyRoundup: buildTableV2Wrapper(useTimoneyRoundup),
  bbbCorporatePurchase: buildTableV2Wrapper(useBbbCorporatePurchase, true),
  bbbCorporateInventory: buildTableV2Wrapper(useBbbCorporateInventory, true),
  bbbLocationPurchase: buildTableV2Wrapper(useBbbLocationPurchase, true),
  fwWingstopSalesAndCompTickets: buildTableV2Wrapper(
    useFwWingstopSalesAndCompTickets,
  ),
  ghaiPopWeekdayAvgLateNight: buildTableV2Wrapper(
    useGhaiPopWeekdayAvgLateNight,
  ),
  fwWingstopSmgBreakdownByStore: buildTableV2Wrapper(
    useFwWingstopSmgBreakdownByStore,
    true,
  ),
  wingitnorthOutliers: buildTableV2Wrapper(useWingitnorthOutliers),
  fwWingstopLocationIntraday: buildTableV2Wrapper(
    useFwWingstopLocationIntraday,
    true,
  ),
  fwWingstopLossPrevention: buildTableV2Wrapper(useFwWingstopLossPrevention),
  fwMarketSssBreakdown: useFwMarketSssBreakdown,
  fwCoreNoncoreSssBreakdown: useFwCoreNoncoreSssBreakdown,
  fwLastTwentyEightDaysTrendData: buildTableV2Wrapper(
    useFwWingstopLastTwentyEightDaysTrendData,
  ),
  fwWingstopR365SalesbyOrderMode: useFwWingstopR365SalesbyOrderMode,
  fwWingstopR365SalesbyOrderModeLocation:
    useFwWingstopR365SalesbyOrderModeLocation,
  manageLocations: useManageLocations,
}

const useApi = (apiName: IApiKeyType) => api[apiName]()

export default useApi
